

angular.module('mtic').constant('MODULE_AVAILABLE_LANGUAGE', {
    //"mtic_gr78_m_meta": ["fr", "en"],
    //"mtic_gr78_m0":["fr", "en"],
    // "mtic_gr78_m1":["fr", "de"],
    // "mtic_gr78_m3":["fr", "de"],
    //"mtic_gr78_m4":["fr", "en"],

    // "mtic_gr78_m2":["fr", "en", "de", "pt"],
    "run_like_math": ["fr", "en", "de", "pt"],
    "mtic_c3_m_meta":["fr", "en", "de", "pt"],
    "mtic_c3_m1":["fr", "en", "de", "pt"],
    "mtic_c3_m0":["en"],
    "mtic_c3_m3":["en", "de", "fr", "pt"]
})
